import "../../../static/js/loaders/jquery";
import "../../../static/js/loaders/modal"
$('.video-block.external').on('click', function (event) {
    event.preventDefault();
    if ($('a', this).attr('target') === '_blank') {
        window.open($('a', this).attr('href'), '_blank')
    }
    else {
        window.location = $('a', this).attr('href');
    }
});